wp?.blocks?.registerBlockStyle( 'seoworks/stat', [
    {
        name: 'circular',
        label: 'Circular',
        isDefault: true
    },
    {
        name: 'hexagonal',
        label: 'Hexagonal',
    }
] );

( function( wp ) {

    const { registerPlugin } = wp?.plugins
    const { PluginDocumentSettingPanel } = wp?.editor
    const { withSelect, withDispatch, useSelect, useDispatch } = wp?.data
    const { compose } = wp?.compose
    const { TextareaControl, TextControl } = wp?.components

    // Service Stat Selection

    const seoworksServiceStatsPanel = ( { postType } ) => {
        if ( postType == 'services' ) {
            return (
                <PluginDocumentSettingPanel
                    name="service-stats-panel"
                    title="Service Statistic"
                    className="service-stats-panel"
                >
                    <SeoworksStat label="Service Statstic" metaKey="service_statistic" />
                    <SeoworksStatDescription label="Service Statstic Description" metaKey="service_statistic_description" />
                </PluginDocumentSettingPanel>
            )
        }
    }

    const postTypewithSelect = withSelect( select => {
        return {
            postType: select( 'core/editor' ).getCurrentPostType(),
        };
    } )( seoworksServiceStatsPanel);

    registerPlugin( 'service-stats-panel', { render: postTypewithSelect , icon: 'airplane' } )

    const SeoworksStat = compose(
        withDispatch( function( dispatch, props ) {
            return {
                setMetaValue: function( value ) {
                    dispatch( 'core/editor' ).editPost( { meta: { [props.metaKey]: value } } );
                }
            }
        } ),
        withSelect( function( select, props ) {
            return {
                metaValue: select( 'core/editor' ).getEditedPostAttribute( 'meta' )[ props.metaKey ],
            }
        } )
    )( function( props ) {
        return (
            <TextControl
                value={ props.metaValue }
                label="Service Statistic"
                onChange={ ( content ) => { props.setMetaValue( content ) } }
            />
        );
    } );

    const SeoworksStatDescription = compose(
        withDispatch( function( dispatch, props ) {
            return {
                setMetaValue: function( value ) {
                    dispatch( 'core/editor' ).editPost( { meta: { [props.metaKey]: value } } );
                }
            }
        } ),
        withSelect( function( select, props ) {
            return {
                metaValue: select( 'core/editor' ).getEditedPostAttribute( 'meta' )[ props.metaKey ],
            }
        } )
    )( function( props ) {
        return (
            <TextareaControl
                value={ props.metaValue }
                label="Service Statistice Description"
                onChange={ ( content ) => { props.setMetaValue( content ) } }
            />
        );
    } );

} )( window.wp )